import { DashboardProvider } from '../../context/dashboard.contex'
import SecondaryDashboardDepartment from './DashboardDepartment'

function DashboardDepartment() {
  return (
      <SecondaryDashboardDepartment/>
  )
}

export default DashboardDepartment